import axios from "axios";

export async function updateUser(
    userId: number,
    data: Record<string, unknown>,
): Promise<void> {
    await axios.patch(`/users/${userId.toString()}`, data);
}

export async function updateUserLocale(
    userId: number,
    localeId: number,
): Promise<void> {
    await updateUser(userId, { locale_id: localeId });
}
